import { UtilityService } from './../../../../../others/services/utility.service';
import { Component, OnInit, ElementRef, HostListener } from '@angular/core';
import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from "src/app/others/services/authentication.service";
import { AlertService } from 'src/app/others/services/alert.service';
import { NgxSpinnerService } from "ngx-spinner";
import { Router } from "@angular/router";

import { CurrencyService } from "src/app/others/services/currency.service";

interface Notification {
  id: string;
  title: string;
  message: string;
  created_at: string;
  status: 'read' | 'unread';
}

interface NotificationResponse {
  notifications: Notification[];
  counts: {
    unread: number;
    read: number;
  };
}


@Component({
  selector: "app-nav-right",
  templateUrl: "./nav-right.component.html",
  styleUrls: ["./nav-right.component.scss"],
  providers: [NgbDropdownConfig],
})
export class NavRightComponent implements OnInit {
  user_array = (str) => {
    return str.trim().split(",");
  };
  facilityCountry: string = sessionStorage.getItem('user_geo_country') || '';

  id: string;
  username: string;
  user: any;
  notifications: Notification[] = [];
  unreadCount: number = 0;
  dropdownOpen: boolean = false;
  readonly truncateLength = 90;
  soundEnabled = true;

  // Currency State
  selectedCurrencyCode: string = 'GH₵';
  selectedCurrencySymbol: string = 'GH₵';
  availableCurrencies = [
    { code: 'GH₵', symbol: 'GH₵', name: 'Ghana Cedi', country: 'Ghana' },
    { code: 'USD', symbol: '$', name: 'US Dollar', country: 'United States' },
    { code: 'NGN', symbol: '₦', name: 'Nigerian Naira', country: 'Nigeria' },
    { code: 'GBP', symbol: '£', name: 'British Pound', country: 'United Kingdom' },
    { code: 'EUR', symbol: '€', name: 'Euro', country: 'Europe' }
  ];


  constructor(
    public auth: AuthenticationService,
    private alert: AlertService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private ulitity: UtilityService,
    private eRef: ElementRef,
    private currency: CurrencyService
  ) { }

  ngOnInit() {
    this.id = this.auth.userID();
    this.getUser();
    this.getNotifications();

    // Check every 30s for new notifications
    setInterval(() => this.getNotifications(), 30000);

    // Load sound preference from localStorage
    const saved = localStorage.getItem('notificationSound');
    if (saved !== null) {
      this.soundEnabled = JSON.parse(saved);
    }
    // Listen for currency/location changes
    this.currency.conversionState$.subscribe(state => {
      this.facilityCountry = state.country;
      this.selectedCurrencyCode = state.code;
      this.selectedCurrencySymbol = state.symbol;
    });
  }

  setAppCurrency(curr: any) {
    this.currency.setCurrency(curr.code, curr.symbol, curr.country);
  }

  //.............................................................. programmer added ...........................................................
  getUser() {
    this.auth.show("user", this.id).subscribe(
      (response) => {
        this.user = response["user"];
        // sessionStorage.removeItem("username");
        // sessionStorage.setItem("username", this.user.othernames);
        this.username = sessionStorage.getItem("username") || localStorage.getItem("username");
      },
      (error) => {
      }
    );
  }

  // logout method
  // logout() {
  //   this.auth.logout()
  //   sessionStorage.clear();
  //   this.router.navigate(["/auth/signin/"]);

  // }

  logout() {
    this.spinner.show();
    this.auth.logout().subscribe(
      (res) => {
        // this.utils.resetProfile();
        this.auth.clearStorage();
        this.router.navigate(['/auth/signin/']);
        // Swal.fire('', res['message'], 'success');
        this.alert.success(res['message']);
        this.spinner.hide();

        this.ulitity.stopTimer();
      },
      (err) => {
        this.spinner.hide();
        this.alert.error('Could not log out, please try again');
      }
    );
  }

  checkLogin() {
    this.auth.isLoggedIn();
  }



  getNotifications() {
    const subdomain = sessionStorage.getItem("subdomain") || localStorage.getItem("subdomain");
    if (!subdomain || subdomain === 'null') {
      return;
    }
    this.auth.get("notifications").subscribe(
      (response: NotificationResponse) => {
        const oldCount = this.unreadCount;

        this.notifications = (response.notifications || []).map(n => ({
          ...n,
          expanded: false
        }));

        this.unreadCount = response.counts?.unread || 0;


        // 🔊 Play sound only if enabled and new notifications exist
        if (this.soundEnabled && this.unreadCount > oldCount) {
          this.playNotificationSound();
        }
      },
      (error) => console.error("Error fetching notifications:", error)
    );
  }

  playNotificationSound() {
    const audio = new Audio('assets/sounds/new-notification-sound.mp3');
    audio.play().catch(err => console.warn("Autoplay blocked:", err));
  }





  toggleDropdown(event: Event) {
    event.stopPropagation();
    this.dropdownOpen = !this.dropdownOpen;


  }


  @HostListener('document:click', ['$event'])
  handleClickOutside(event: Event) {
    if (this.dropdownOpen && !this.eRef.nativeElement.contains(event.target)) {
      this.dropdownOpen = false;
      this.markAllAsRead();
    }
  }



  markAllAsRead() {
    this.auth.store("notifications/mark-all-read", {}).subscribe(
      (response) => {
        // Update local state
        this.notifications = this.notifications.map(notification => ({
          ...notification,
          status: 'read'
        }));
        this.unreadCount = 0;
      },
      (error) => {
        console.error("Error marking all as read:", error);
      }
    );
  }

  clearAll() {
    this.auth.store("notifications/clear-all", {}).subscribe(
      (response) => {
        // Update local state
        this.notifications = [];
        this.unreadCount = 0;
      },
      (error) => {
        console.error("Error clearing all notifications:", error);
      }
    );
  }



  toggleSound() {

    this.soundEnabled = !this.soundEnabled;
    localStorage.setItem('notificationSound', JSON.stringify(this.soundEnabled));

    if (this.soundEnabled) {
      this.playNotificationSound();
    }
  }



  goToReportTable(url: string) {
    if (url) {
      this.router.navigate([url]);
    }
  }

  //.............................................................. programmer added ...........................................................
}
